import MFAContent from './MFAContent'

export default MFAContent
